import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import CompanyCoursesTemplate from '@components/CompanyCourses/CompanyCourses';
import CompanyCoursesAreasTemplate from '@components/CompanyCoursesAreas/CompanyCoursesAreas';
import CompanyCoursesContactFormTemplate from '@components/CompanyCoursesContactForm/ContactForm';
import CompanyCoursesProcessTemplate from '@components/CompanyCoursesProcess/CompanyCoursesProcess';
import CompanyCoursesSupportTemplate from '@components/CompanyCoursesSupport/CompanyCoursesSupport';
import FooterTemplate from '@components/Footer/Footer';
import Gallery from '@components/Gallery/Gallery';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import HeroTemplate from '@ui/Hero/Hero';
import { IS_PROD } from '../constants';

interface ICompanyCourses {}

const CompanyCourses: NextPage<ICompanyCourses> = () => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo title={t('seo.companyCourses.title')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <HeroTemplate
                titleKey="companyCourses.hero.title"
                imageKey="company_courses_hero.png"
                descriptionKey="companyCourses.hero.paragraph"
            />
            <CompanyCoursesProcessTemplate />
            <CompanyCoursesTemplate />
            <CompanyCoursesAreasTemplate />
            <Gallery />
            <CompanyCoursesSupportTemplate />
            <CompanyCoursesContactFormTemplate />
            <FooterTemplate />
        </>
    );
};

export default CompanyCourses;
